import React from "react";
import "./styles.scss";
import { Popconfirm } from "antd";
import { getLanguage } from "../../utils";

const lan = getLanguage();

const CategoryCard = (props) => {
  const onClickCancel = (e) => {
    console.log(e);
  };
  return (
    <>
      <div
        className={`hne-category-card-wrapper ${
          props.isSelect ? "active" : ""
        }`}
      >
        <div className="ccw-id">{props.id}</div>
        {lan === "si" && (
          <div
            className="ccw-SI"
            dangerouslySetInnerHTML={{ __html: props.nameSI }}
          ></div>
        )}
        <div
          className="ccw-EN"
          dangerouslySetInnerHTML={{ __html: props.nameEN }}
        ></div>
        <div className="ccw-edit" onClick={props.onClick}>
          {props.edit}
        </div>
        <div className="ccw-delete">
          <Popconfirm
            placement="topLeft"
            title="Delete the image"
            description="Are you sure to delete this Image?"
            onConfirm={props.onClickRemove}
            onCancel={onClickCancel}
            okText="Yes"
            cancelText="No"
          >
            {props.delete}
            {/* <span className="remove-button"> {GetIconByName("cross")}</span>{" "} */}
          </Popconfirm>
          {/* {props.delete} */}
        </div>
      </div>
    </>
  );
};
export default CategoryCard;
